module.exports = __webpack_public_path__ + "img/InAppbannerROG_JFXGOLDX.d84ac404.png";